/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type FinancingProvider = 'None' | 'GreenSky' | 'ServiceFinance' | 'Turns' | 'Financeit';

export const FinancingProvider = {
    None: 'None' as FinancingProvider,
    GreenSky: 'GreenSky' as FinancingProvider,
    ServiceFinance: 'ServiceFinance' as FinancingProvider,
    Turns: 'Turns' as FinancingProvider,
    Financeit: 'Financeit' as FinancingProvider
}